import { useTranslation } from 'react-i18next';

import { AddContextMenu } from './AddContextMenu';
import {
    incomeAddButtonOrder,
    type IncomeType,
    incomeTypeConfig,
} from '~/features/leadDetails/components/Overview/CustomerData/Income/incomeTypeConfig.ts';

type Props = {
    onAdd: (type: IncomeType) => void;
};

export const AddIncome: React.FC<Props> = ({ onAdd }) => {
    const { t } = useTranslation();

    return (
        <AddContextMenu
            ariaLabel={t('LEADS.DETAILS.INCOME.ADD')}
            getLabel={(type) => t(incomeTypeConfig[type].label)}
            itemTypes={incomeAddButtonOrder}
            onAdd={onAdd}
        />
    );
};
